import { render, staticRenderFns } from "./true-false.vue?vue&type=template&id=9f3a3c50&scoped=true"
import script from "./true-false.ts?vue&type=script&lang=ts&external"
export * from "./true-false.ts?vue&type=script&lang=ts&external"
import style0 from "./true-false.scss?vue&type=style&index=0&id=9f3a3c50&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f3a3c50",
  null
  
)

export default component.exports